import React from 'react';

import Thumb from '../img/taxa.jpg';
import Img from '../img/taxa2.png';

const TaxaWPTheme = {
    id: 12, permalink: "taxa-wp-theme", thumb: Thumb, title: "Taxa WordPress Theme", category: "WordPress", categoryURL: "wordpress", detailImg1: Thumb, detailImg2: Img, previewTxt: "", previewURL: "", sourceTxt: "GitHub", sourceURL: "https://github.com/wasek23/taxa-wp-theme", description: <>
        <h3 className="mbSmall">Taxa is a WordPress Theme.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>5+ type posts developed, services, packages, places, members, blogs.</li>
            <li>Dynamic sidebar.</li>
            <li>Newsletter form with custom code.</li>
            <li>Google Map Added in contact page</li>
            <li>Contact Form development without using plugin</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>WordPress, PHP, JavaScript, jQuery, HTML, CSS, Redux</li>
        </ul>
    </>
};
export default TaxaWPTheme;